export const engagementCampaignsAppGroupIdCampaignsWithExceptions =
  "/engagement/campaigns/:app_group_id/campaigns_with_exceptions";
